import type { VerificationType } from 'services/EpdClient';
import { DocumentDataSourceOption } from 'types/dynamic-forms/DocumentDataSourceOption';

/** VerificationType.EPDPreverifiedTool, held as a type-checked literal: Jest cannot load EpdClient at runtime. */
const FULLY_PREVERIFIED_TOOL: `${VerificationType}` = 'FullyPreverifiedTool';

/**
 * #20154 As in the Simple Wizard: the Pre-verified & Integrated tool type lists only fully pre-verified tools,
 * every other type lists only the other tools. The backend removes a stored tool that does not fit the type.
 */
export default function filterToolOptionsByVerificationType(
  options: DocumentDataSourceOption[],
  verificationType: string | null | undefined
): DocumentDataSourceOption[] {
  const needsFullyPreverifiedTool = verificationType === FULLY_PREVERIFIED_TOOL;
  return options.filter((o) => !!o.meta?.isFullyPreverified === needsFullyPreverifiedTool);
}
